import type { IContractNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createContractNote,
  updateNote: updateContractNote,
  deleteNote: deleteContractNote,
} = makeNoteService<IContractNote>('/api/contractnotes', 'contractNote')
